import { useState } from 'react';
import axiosInstance from 'interceptor/axiosInstance';
import { generatePath } from 'react-router-dom';
import { ApiRoutes } from 'routes/routeConstants/apiRoutes';
import Notification from 'shared/components/Notification';
import { NotificationTypes } from 'enums/notificationTypes';
import { dataUpdatedMessage } from 'constants/constants';
import { ManualScope3Category } from 'constants/Scope3Constants/manualScope3Categories.constants';
import {
  Scope3ManualEmissionPayload,
  Scope3ManualEmissionResponse,
} from 'models/Scope3/scope3ManualEmission.model';

const Scope3ManualEmissionService = () => {
  const [loading, setLoading] = useState<boolean>(false);

  const fetchManualEmission = async (
    locationId: string,
    year: string | number,
    category: ManualScope3Category
  ): Promise<Scope3ManualEmissionResponse | undefined> => {
    try {
      setLoading(true);
      const url = generatePath(ApiRoutes.SCOPE_CATEGORY, {
        locationId,
        year,
        category,
      });
      const response = await axiosInstance.get(url);
      const { unit = null, emissions = null } = response?.data ?? {};
      return { unit, emissions };
    } catch (error) {
    } finally {
      setLoading(false);
    }
  };

  const updateManualEmission = async (
    locationId: string,
    year: string | number,
    category: ManualScope3Category,
    payload: Scope3ManualEmissionPayload
  ) => {
    try {
      setLoading(true);
      const url = generatePath(ApiRoutes.SCOPE_CATEGORY, {
        locationId,
        year,
        category,
      });
      const response = await axiosInstance.put(url, payload);
      Notification({
        message: response?.data?.message ?? dataUpdatedMessage,
        description: '',
        type: NotificationTypes.SUCCESS,
      });
      return true;
    } catch (error) {
    } finally {
      setLoading(false);
    }
  };

  return {
    loading,
    fetchManualEmission,
    updateManualEmission,
  };
};

export default Scope3ManualEmissionService;
